//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import UserId from '@models/UserId';

export interface IEligibleUser {
  userId: UserId;
  name: string;
  email: string;
}

export enum ScheduleInstagramPostErrorCode {
  // 200 Range: Things wrong with the post
  INSTAGRAM_PUBLISHING_UNSUPPORTED_ASPECT_RATIO = 201,
  INSTAGRAM_PUBLISHING_IMAGE_SIZE_TOO_LARGE = 202,
  INSTAGRAM_PUBLISHING_INVALID_TAGGED_USER = 203,

  // 400 Range: Unrecoverable errors
  INSTAGRAM_PUBLISHING_UNEXPECTED_ERROR = 400,
  INSTAGRAM_PUBLISHING_PERMISSION_DENIED_EXCEPTION = 401,
  INSTAGRAM_PUBLISHING_INVALID_PARAMETER = 402,

  // 500 Range: Unexpected service related issues
  INSTAGRAM_PUBLISHING_UNEXPECTED_RETRIABLE_ERROR = 500,
  INSTAGRAM_PUBLISHING_EXPIRED_TOKEN = 501,
  INSTAGRAM_PUBLISHING_THROTTLING_EXCEPTION = 502,
  INSTAGRAM_PUBLISHING_OAUTH_EXCEPTION = 503,
  INSTAGRAM_PUBLISHING_UPLOAD_EXCEPTION = 504,
  INSTAGRAM_PUBLISHING_MEDIA_NOT_READY_EXCEPTION = 505,
  INSTAGRAM_PUBLISHING_DOWNLOAD_TIMEOUT = 506,
  INSTAGRAM_PUBLISHING_FEATURE_BLOCKED = 507,
  INSTAGRAM_PUBLISHING_INTERMITTENT_VIDEO_FAILURE = 508,
  INSTAGRAM_PUBLISHING_MEDIA_CONTAINER_CORRUPTED = 509,
}

export function isInstagramPublishingErrorCodeUserFixable(
  code: ScheduleInstagramPostErrorCode,
) {
  return code < 400;
}

export function isInstagramPublishingErrorRecoverable(
  code: ScheduleInstagramPostErrorCode,
) {
  return code < 400 || code >= 500;
}
